import React, { createContext, useContext, useRef } from 'react';

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children }) => {
  const toast = {
    success: (message, options = {}) => {
      if (typeof window !== 'undefined' && window.toastManager) {
        return window.toastManager.addToast({
          type: 'success',
          message,
          ...options
        });
      }
    },
    error: (message, options = {}) => {
      if (typeof window !== 'undefined' && window.toastManager) {
        return window.toastManager.addToast({
          type: 'error',
          message,
          duration: 7000, // Longer duration for errors
          ...options
        });
      }
    },
    warning: (message, options = {}) => {
      if (typeof window !== 'undefined' && window.toastManager) {
        return window.toastManager.addToast({
          type: 'warning',
          message,
          ...options
        });
      }
    },
    info: (message, options = {}) => {
      if (typeof window !== 'undefined' && window.toastManager) {
        return window.toastManager.addToast({
          type: 'info',
          message,
          ...options
        });
      }
    },
    // Helper method for API responses
    apiResponse: (success, message, title) => {
      if (success) {
        toast.success(message, { title });
      } else {
        toast.error(message, { title });
      }
    }
  };

  return (
    <ToastContext.Provider value={{ toast }}>
      {children}
    </ToastContext.Provider>
  );
};

export default ToastContext;